import { cn } from "@/lib/utils";

const VARIANTS = {
  have: "border-ok text-ok bg-[#EEF5EE]",
  bought: "border-ok text-ok bg-[#EEF5EE]",
  need_to_buy: "border-masking text-masking-700 bg-masking-50",
  not_needed: "border-stone_border text-timber-500 bg-chalk",
  unsure: "border-denim text-denim bg-denim-50",
  done: "border-ok text-ok bg-[#EEF5EE]",
  current: "border-masking text-masking-700 bg-masking-50",
  not_started: "border-stone_border text-timber-700 bg-chalk",
  blocked: "border-block text-block bg-[#FBEDEE]",
  active: "border-denim text-denim bg-denim-50",
  paused: "border-timber-500 text-timber-700 bg-chalk",
  ready: "border-ok text-ok bg-[#EEF5EE]",
  in_progress: "border-denim text-denim bg-denim-50",
  completed: "border-ok text-ok bg-[#EEF5EE]",
  complete: "border-ok text-ok bg-[#EEF5EE]",
  awaiting_materials: "border-masking text-masking-700 bg-masking-50",
};

const LABELS = {
  have: "Have",
  bought: "Bought",
  need_to_buy: "Need to buy",
  not_needed: "Not needed",
  unsure: "Unsure",
  done: "Done",
  current: "Current",
  not_started: "Up next",
  blocked: "Blocked",
  active: "Active",
  paused: "Paused",
  ready: "Ready to finish",
  in_progress: "In progress",
  completed: "Completed",
  complete: "Complete",
  awaiting_materials: "Awaiting materials",
};

export default function StatusPill({ status, label, className }) {
  const variant = VARIANTS[status] ?? VARIANTS.not_started;
  return (
    <span
      data-testid={`pill-${status}`}
      className={cn(
        "inline-flex items-center rounded-full border-2 px-3 py-1 text-xs font-bold uppercase tracking-wide",
        variant,
        className,
      )}
    >
      {label ?? LABELS[status] ?? status}
    </span>
  );
}
